export default {
  edit_profile: 'Editar perfil',
  my_account: 'Minha conta',
  balance: 'Saldo',
  available_for_withdrawal: 'Disponível para saque',
  amount_in_hold: 'Valor Retido',
  latest_news: 'Últimas notícias',
  more_news: 'Mais notícias'
};